<script>
import { eventBus } from '../../../Pages/assets/eventBus.js';
export default {
    props: {
        disabledAsc: Boolean,
        disabledDesc: Boolean,
        sortParam: String,
        ascSortValue: String,
        descSortValue: String
    },
    
    methods: {
        sortingTrigger(column, value) {
            eventBus.sortingColumn(column, value);
        }
    }
};
</script>

<template>
    <div class="btn-group-vertical">
        <a href="Javascript:void(0)" class="btn btn-xs btn-link p-0 d-inline-flex justify-content-center align-items-center" :class="{'disabled': disabledAsc}" @click="sortingTrigger(sortParam, ascSortValue)">
            <i class="fas fa-sort-up"></i>
        </a>
        <a href="Javascript:void(0)" class="btn btn-xs btn-link p-0 d-inline-flex justify-content-center align-items-center" :class="{'disabled': disabledDesc}" @click="sortingTrigger(sortParam, descSortValue)" style="margin-top: -10px !important;">
            <i class="fas fa-sort-down"></i>
        </a>
    </div>
</template>
